<template>
    <div class="is-relative ">
        <section class="hero">
            <div class="hero-body">
                <b-loading v-if="!ticket" v-model="isLoading" :is-full-page="false" />
                <div v-if="ticket">
                    <section class="box">
                        <h1 class="title">{{ $_get(ticket, 'title') }}</h1>
                        <p>{{ $_get(ticket, 'description') }}</p>

                        <div class="columns mt-5 is-1">
                            <div class="column">
                                <div class="buttons">
                                    <b-button icon-left="play-circle" type="is-success" :loading="testIsCreating" :desibled="testIsCreating" @click.prevent="create">Начать тестирование</b-button>


                                    <span class="px-2"><b-icon icon="ticket-outline" /> {{ticket.questionsAmount}}</span>
                                    <template v-if="ticket.timeLimit"><b-icon icon="timer-outline" /> {{ticket.timeLimit | seconds2duration}}</template>
                                    <template v-else><b-icon icon="timer" /></template>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import ContextMixin from '../../../mixins/ContextMixin'

export default {
    mixins: [
        ContextMixin,
    ],
    created () {
        if (!this.ticket) {
            this.fetchById(this.ticketId)
        }
    },
    methods: {
        ...mapActions({
            fetchById: 'e/tickets/fetchById',
            createTest: 'e/tests/create',
        }),
        create() {
            return this.createTest(this.ticketId).then(e => {
                this.$router.push({name: 'tests.show', params: {id: e.data.data.id}})
            })
        },
        contextChangedHandler() {
            this.$router.push({name: 'tickets.index'})
        }
    },
    computed: {
        ...mapGetters({
            ticketById: 'e/tickets/ticketById',
            isLoaderActive: 'e/pages/isLoaderActive',
        }),
        isLoading() {
            return this.isLoaderActive('tickets.fetchById')
        },
        testIsCreating() {
            return this.isLoaderActive('tests.create')
        },
        ticketId () {
            return this.$route.params.id
        },
        ticket () {
            return this.ticketById(this.ticketId)
        },
    },
}
</script>
